export const environment = {
  urlConfig: {
    serviceUrl: 'https://service.seoflurry.com/api/launchpad/v1',
    signalRBaseUrl: 'https://service.seoflurry.com/signalr',
    reportingUrl: 'https://reporting.boostability.com',
    myMarketInfoUrl: 'https://mymarketinfo.com',
    launchpadUrl: 'https://launchpad.boostability.com',
    launchpadCommandUrl: 'https://launchpadcommand.boostability.com',
    yellowLogoutUrl: 'http://digital.sensis.com.au/okta/IdP_Logout.htm',
    restrictedReportingUrls: ['mymarketinfo.com', 'www.mymarketinfo.com'],
    frontAppUrl: 'https://app.frontapp.com',
    hangfireUrl: 'https://hangfire.mymarketinfo.com',
  },
  testConfig: {
    testMessage: '',
    showTestMessage: false,
    logToConsole: false,
    usernamesChangedForTesting: false
  },
  defaultPartnerConfig: {
    id: 1,
    name: 'Boostability',
    logoLargeS3Url: 'https://s3.amazonaws.com/s3staticfiles/logos/1/03cfb792-397a-402f-912b-b6dc6977b8eb.png',
    logoSmallS3Url: 'https://s3.amazonaws.com/s3staticfiles/logos/1/cdea5b9a-2826-4156-96a8-b5bac7a681d1.png',
  },
  logToGoogleAnalytics: true,
  logToDevGoogleAnalytics: false,
  disableAngularDebugChecks: true,
  jsBuildDate: 1793727066428,
  authNetEditPaymentUrl: 'https://accept.authorize.net/customer/editPayment',
  authNetAddPaymentUrl: 'https://accept.authorize.net/customer/addPayment',
  authNetIframeCommunicator: 'https://launchpad.boostability.com/assets/auth-net/iFrameCommunicator.html'
};
